module.exports = __webpack_public_path__ + "media/bootstrap-icons/check-square-fill-78acac9a.svg";